const UseGetterNodeValue = (currentNode, tabName, fieldName, defaultValue) => {
    return currentNode?.data?.form?.tabs?.[tabName]?.fields?.[fieldName]?.value ?? defaultValue;
}

export default UseGetterNodeValue

